import { render } from "./FaqForm.vue?vue&type=template&id=b752c87a"
import script from "./FaqForm.vue?vue&type=script&lang=js"
export * from "./FaqForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__